import { LastMessageText } from '@halo/ui-chat-react';
import { Flex, Text } from '@chakra-ui/react';
import { MyTrans } from '@halo/ui-react';
import { useMsgMediaTitle } from '../msg-media-call';
import type { MsgMediaHangUpContentProps } from './msg-media-hang-up-content';
import { MsgMediaHangUpContent } from './msg-media-hang-up-content';

export interface MsgMediaHangUpPreviewProps extends MsgMediaHangUpContentProps {}

export const MsgMediaHangUpPreview = memo(function MsgMediaHangUpPreview({
  message,
}: MsgMediaHangUpPreviewProps) {
  const { type } = message.payload;

  const { title } = useMsgMediaTitle({ type });

  return (
    <LastMessageText>
      <Flex alignItems="center">
        <Text as="span" color="fg.muted">
          {title}
        </Text>
        <MsgMediaHangUpContent message={message}>
          {({ typeDisplay, duration }) => (
            <MyTrans
              i18nKey="chat.mediaCallHangUpText"
              components={{
                component: <Text as="span" color="fg.muted" px="0.5" />,
              }}
              values={{
                callType: typeDisplay,
                duration: duration,
              }}
            ></MyTrans>
          )}
        </MsgMediaHangUpContent>
      </Flex>
    </LastMessageText>
  );
});
